<div>
  <div class="map-service-icons">
    <div class="icon-wrapper">
      <div
        (click)="showBaseMapView()"
        class="base-mapover"
        pTooltip="Base Maps"
        tooltipPosition="left"
        placeholder="Left"
      >
        <span class="csx-layout_grid_small layer-icon"></span>
      </div>
    </div>

    <csx-base-maps
      [hidden]="!isShowBaseMaps"
      (hideBaseMaps)="hideBaseMaps($event)"
    ></csx-base-maps>
  </div>
</div>
